"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactQuery = require("react-query");
var _reactI18next = require("react-i18next");
var _lodash = require("lodash");
var _core = require("@material-ui/core");
var _axios = _interopRequireDefault(require("axios"));
var _queryString = _interopRequireDefault(require("query-string"));
var _ReactMetadata = _interopRequireDefault(require("@micado-digital/react-metadata/ReactMetadata01"));
var _contactSection = _interopRequireDefault(require("../../components/contact-section"));
var _elementHeadline = _interopRequireDefault(require("../../components/element-headline"));
var _gallery = _interopRequireDefault(require("../../components/gallery"));
var _references = _interopRequireDefault(require("../../components/references"));
var _text = _interopRequireDefault(require("../../components/text"));
var _themeTeaser = _interopRequireDefault(require("../../components/theme-teaser"));
var _pageContext = _interopRequireDefault(require("../../context/pageContext"));
var _changeLanguage = _interopRequireDefault(require("../../utils/changeLanguage"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const ListMenus = _ref => {
  let {
    data,
    providers
  } = _ref;
  const {
    i18n
  } = (0, _reactI18next.useTranslation)();
  const topThemeTeasers = data.filter(item => {
    return item === null || item === void 0 ? void 0 : item.top;
  }).map(item => {
    var _item$media;
    return {
      teaser: {
        id: item === null || item === void 0 ? void 0 : item.id,
        link: "/".concat(i18n.language, "/cuisine/").concat(item === null || item === void 0 ? void 0 : item.id).concat(providers ? "?providers=".concat(providers) : ""),
        media: (_item$media = item === null || item === void 0 ? void 0 : item.media) !== null && _item$media !== void 0 ? _item$media : [],
        title: item === null || item === void 0 ? void 0 : item.title,
        from: item === null || item === void 0 ? void 0 : item.dateFrom,
        to: item === null || item === void 0 ? void 0 : item.dateTo
      }
    };
  });
  const links = data.filter(item => {
    return !item.top;
  }).map(item => {
    return {
      id: item === null || item === void 0 ? void 0 : item.id,
      reference: {
        pageName: "/".concat(i18n.language, "/cuisine/").concat(item === null || item === void 0 ? void 0 : item.id).concat(providers ? "?providers=".concat(providers) : ""),
        title: item === null || item === void 0 ? void 0 : item.title
      },
      title: item === null || item === void 0 ? void 0 : item.title
    };
  });
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, topThemeTeasers.map(item => {
    var _item$teaser;
    return /*#__PURE__*/_react.default.createElement(_themeTeaser.default, {
      data: item,
      key: item === null || item === void 0 || (_item$teaser = item.teaser) === null || _item$teaser === void 0 ? void 0 : _item$teaser.id,
      mediaFormat: "provider-infrastructure-theme-teaser"
    });
  }), links.length > 0 && /*#__PURE__*/_react.default.createElement(_references.default, {
    data: {
      elements: [...links]
    },
    hasBackground: true
  }));
};
const LayoutProviderInfrastructure = _ref2 => {
  var _queryString$parse$pr, _queryString$parse, _facilities$data;
  let {
    match,
    location
  } = _ref2;
  const {
    id,
    lang
  } = match.params;
  const {
    search
  } = location;
  const {
    REACT_APP_PATH,
    REACT_APP_PROVIDER_ID,
    REACT_APP_INFRASTRUCTURE_GALLERY
  } = process.env;
  const [pageData, setPageData] = (0, _react.useContext)(_pageContext.default);
  const [providers] = (0, _react.useState)((_queryString$parse$pr = (_queryString$parse = _queryString.default.parse(search)) === null || _queryString$parse === void 0 ? void 0 : _queryString$parse.providers) !== null && _queryString$parse$pr !== void 0 ? _queryString$parse$pr : "");
  const {
    i18n,
    t
  } = (0, _reactI18next.useTranslation)();
  (0, _react.useEffect)(() => {
    var _pageData$data;
    if ((pageData === null || pageData === void 0 || (_pageData$data = pageData.data) === null || _pageData$data === void 0 || (_pageData$data = _pageData$data.meta) === null || _pageData$data === void 0 ? void 0 : _pageData$data.title) === t("site.ui.pagetitles.home")) {
      return;
    }
    const additionalPageData = {
      ...pageData
    };
    additionalPageData.data = {
      ...pageData.data,
      meta: {
        title: t("site.ui.pagetitles.home")
      }
    };
    setPageData(additionalPageData);
  });
  const showInfrastructureGallery = JSON.parse(REACT_APP_INFRASTRUCTURE_GALLERY);
  const urlFacilities = "".concat(REACT_APP_PATH, "/Micado.Tourism.Web/Micado.Tourism.Web.IO.Api.ProviderApi/ListFacilities.api?providers=").concat(providers ? providers : REACT_APP_PROVIDER_ID, "&lang=").concat(lang, "&selected=").concat(id);
  const {
    data: facilities,
    status: statusFacilities
  } = (0, _reactQuery.useQuery)(["list-facilities", lang, providers, id], () => _axios.default.get(urlFacilities));
  const urlMenus = "".concat(REACT_APP_PATH, "/Micado.Tourism.Web/Micado.Tourism.Web.IO.Api.ProviderApi/ListMenus.api?lang=").concat(lang, "&facilityid=").concat(id);
  const {
    data: menus,
    status: statusMenus
  } = (0, _reactQuery.useQuery)(["list-menus", lang, id], () => _axios.default.get(urlMenus));
  if (statusFacilities !== "success" || statusMenus !== "success") return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
  if (lang !== i18n.language) {
    (0, _changeLanguage.default)(i18n, lang);
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
  }
  const item = (0, _lodash.first)(facilities === null || facilities === void 0 || (_facilities$data = facilities.data) === null || _facilities$data === void 0 ? void 0 : _facilities$data.items);
  const {
    description,
    media = [],
    title,
    email,
    phone,
    urls
  } = item || {};
  const galleryData = media === null || media === void 0 ? void 0 : media.map(item => {
    return {
      media: [item]
    };
  });
  const references = urls === null || urls === void 0 ? void 0 : urls.map((item, index) => {
    return {
      id: index,
      addition: "_blank",
      text: item === null || item === void 0 ? void 0 : item.url,
      title: item === null || item === void 0 ? void 0 : item.title
    };
  });
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_ReactMetadata.default, {
    lang: i18n.language,
    title: title
  }), /*#__PURE__*/_react.default.createElement(_core.Box, {
    my: 6
  }, title && /*#__PURE__*/_react.default.createElement(_core.Box, {
    my: 6
  }, /*#__PURE__*/_react.default.createElement(_elementHeadline.default, {
    title: title,
    component: "h1"
  })), galleryData && showInfrastructureGallery && /*#__PURE__*/_react.default.createElement(_gallery.default, {
    data: {
      elements: galleryData
    }
  }), description && /*#__PURE__*/_react.default.createElement(_core.Box, {
    my: 6
  }, /*#__PURE__*/_react.default.createElement(_text.default, {
    data: {
      text: description
    }
  })), (email || phone) && /*#__PURE__*/_react.default.createElement(_core.Box, {
    my: 6
  }, /*#__PURE__*/_react.default.createElement(_contactSection.default, {
    email: email,
    phone: phone
  })), references && /*#__PURE__*/_react.default.createElement(_references.default, {
    data: {
      elements: [...references]
    },
    hasBackground: true
  }), menus && /*#__PURE__*/_react.default.createElement(ListMenus, {
    data: menus === null || menus === void 0 ? void 0 : menus.data,
    providers: providers
  })));
};
var _default = exports.default = LayoutProviderInfrastructure;